import { render, staticRenderFns } from "./index.vue?vue&type=template&id=736fcb65&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=736fcb65&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736fcb65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736fcb65')) {
      api.createRecord('736fcb65', component.options)
    } else {
      api.reload('736fcb65', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=736fcb65&scoped=true", function () {
      api.rerender('736fcb65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/storeContract/index.vue"
export default component.exports